export const Config = {
    primaryColor: "#8c2167",
    secondaryColor: "rgb(211,100,91)",
    tertiaryColor: "rgb(202,81,127)",
};